import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=1d196e82&scoped=true"
import script from "./Activate.vue?vue&type=script&lang=js"
export * from "./Activate.vue?vue&type=script&lang=js"
import style0 from "./Activate.vue?vue&type=style&index=0&id=1d196e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d196e82",
  null
  
)

export default component.exports